import { render, staticRenderFns } from "./custom-input-field.vue?vue&type=template&id=122c85d7"
import script from "./custom-input-field.vue?vue&type=script&lang=js"
export * from "./custom-input-field.vue?vue&type=script&lang=js"
import style0 from "./custom-input-field.vue?vue&type=style&index=0&id=122c85d7&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports